<template>
  <b-container fluid>
    <div class="white-box" style="height: 34px; display:none;">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/de-para' }">De-para</el-breadcrumb-item>
        <el-breadcrumb-item>Configurar {{ contextoName }}</el-breadcrumb-item> 
      </el-breadcrumb>
    </div>
    <el-tabs type="border-card" v-model="activeName">
      <div class="menu-status">
            <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelectContext">
              <el-menu-item index="1">Pendentes</el-menu-item>
              <el-menu-item index="2">Revisão</el-menu-item>
              <el-menu-item index="3">Aprovados</el-menu-item>
            </el-menu>
          </div>
      <el-tab-pane :name="activeNameInfo">
        <span slot="label"> 
          <i v-if="activeNameInfo === 'Franqueado'" class="fas fa-user"></i>
          <i v-else class="fas fa-users"></i>
          &nbsp;
          {{ activeNameInfo }} - {{ $route.query.nome }}
        </span>
        <router-view></router-view>
        <div class="actions-depara">
          <div class="float-left">
            <el-button title="Voltar para filtro de De-Para" size="small" icon="el-icon-back" @click="voltarDePara"> Filtro de De-Para</el-button>
            
          </div>
          <div class="float-right">
            <el-tooltip class="item" effect="dark" content="Gerar relatório" placement="left-end">
              <el-popover
                  placement="bottom"
                  width="230"
                  v-model="gerarRelatorioVisivel">
                  <p>Deseja gerar um relatório com as informações de De-Para?</p>
                  <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="gerarRelatorioVisivel = false">Não</el-button>
                      <el-button type="primary" size="mini" @click="gerarRelatorio">Sim</el-button>
                  </div>
                  <el-button v-if="temAcesso('DePara','Exportar')" size="small" class="btn-gerar-relatorio" type="success" icon="el-icon-download" slot="reference"> Gerar relatório </el-button>
                  <el-button v-else class="btn-gerar-relatorio no-drop" size="small" disabled icon="el-icon-download" slot="reference" v-b-tooltip.hover title="Sem permissões"> Gerar relatório </el-button>
              </el-popover>
              
            </el-tooltip>
          </div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane name="Franqueador" v-if="activeName === 'Franqueador'">
        <span slot="label"><i class="far fa-chart-bar"></i> Franqueador </span>
        <router-view></router-view>
      </el-tab-pane> -->
    </el-tabs>
  </b-container>
</template>
<script>

export default {
  name: 'DeParaRouterView',
  data() {
    return { 
      activeName: 'Franqueado',
      contextView: '',
      activeIndex: '1',
      gerarRelatorioVisivel: false
    }
  },
  computed: {
    contextoName() {
      let name = ''
      switch(this.$route.meta.contexto) {
        case 'pendente':
          name = 'Pendente'
          this.activeIndex = '1'
          break;
        case 'revisao':
          name = 'Revisão'
          this.activeIndex = '2'
          break;
        case 'aprovado':
          name = 'Aprovado'
          this.activeIndex = '3'
          break;
      }

      return name
    },
    activeNameInfo() {
      let name = this.$route.path.split('/')[2]
      let captalize = name.charAt(0).toUpperCase() + name.slice(1)
      this.activeName = captalize
      return captalize
    }
  },
  methods: {
    handleSelectContext(key) {
      const name = this.activeName
      let selectedContextName = ''
      switch(key) {
        case '1':  selectedContextName = 'pendente'; break;
        case '2':  selectedContextName = 'revisao'; break;
        case '3':  selectedContextName = 'aprovado'; break;
      }

      const routerName = `de-para-${name.toLowerCase()}-${selectedContextName}`
      
      this.$router.push({name: routerName, query: this.$route.query })
    },
    handleTabClick(tab) {
      const name = this.activeName
      const context = this.$route.meta.contexto
      const routeNameNext = `de-para-${name.toLowerCase()}-${context}`

      if(this.$route.name === routeNameNext) {
        return
      }

      this.$router.replace({ name: routeNameNext })
    },
    gerarRelatorio() {
      this.requestGerarRelatorio();
      this.gerarRelatorioVisivel = false;
    },
    voltarDePara() {
      this.$router.push({name: 'de-para' })
    },
    async requestGerarRelatorio(){
      let request = await this.axios.get(this.$urls.DE_PARA_GERACAO_RELATORIO, {
              params: {
                  CustomerId: this.$route.params.customerId,
                  //ClusterIds: this.modelFiltro.ClusterIds.join(','),
                  Marcas: this.$route.query.marcas,
                  visao: this.activeName
              }
          });

      if(request.status !== 200) {
          this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
          return;
      }

      this.$notify({
          type: "success",
          title: 'Gerando Relatório',
          dangerouslyUseHTMLString: true,
          message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
      });
    }
  }
};
</script>
<style lang="scss">
.menu-status {
    right: 2px;
    position: absolute;
    top: -36px;
    background: #fff;
    height: 32px;
  .el-menu.el-menu--horizontal {
    border: 0;
    .el-menu-item {
      float: left;
      height: 24px;
      line-height: inherit;
      padding: 5px 8px 28px;
      &.is-active:nth-of-type(1) {
          border-color: #ff604b;
      }
      &.is-active:nth-of-type(2) {
          border-color: #ffb56b;
      }
      &.is-active:nth-of-type(3) {
          border-color: #5aca78;
      }
    }
  }
}
.actions-depara {
    position: relative;
    padding: 11px 5px 5px;
    display: block;
    background: #FFF;
    width: 100%;
    height: 44px;
    margin-top: 15px;
    border-top: 1px solid #e3e3e3;
}
</style>
